import { render } from "./SubSecondSettings.vue?vue&type=template&id=f8587160&scoped=true"
import script from "./SubSecondSettings.vue?vue&type=script&lang=js"
export * from "./SubSecondSettings.vue?vue&type=script&lang=js"

import "./SubSecondSettings.vue?vue&type=style&index=0&id=f8587160&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8587160"],['__file',"src/views/SubSecondStreaming/SubSecondSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8587160"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8587160', __exports__)) {
    api.reload('f8587160', __exports__)
  }
  
  module.hot.accept("./SubSecondSettings.vue?vue&type=template&id=f8587160&scoped=true", () => {
    api.rerender('f8587160', render)
  })

}


export default __exports__